import React, { useState, useEffect } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { RdetailTable } from "./RdetailTable";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchAll,
} from "./rdetailSlice";

export const RDetailPage = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);

  // Filter
  const [rayonType, setRayonType] = useState("");
  const [archiGroup, setArchiGroup] = useState("");
  const [division, setDivision] = useState("");
  const [validFrom, setValidFrom] = useState("");
  const [validTo, setValidTo] = useState("");
  const [material, setMaterial] = useState("");

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  const handleSearch = () => {
    const params = {
      rayonType: rayonType,
      archiGroup: archiGroup,
      division: division,
      validFrom: validFrom,
      validTo: validTo,
      material: material,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    dispatch(fetchAll(params));
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    const params = {
      rayonType: rayonType,
      archiGroup: archiGroup,
      division: division,
      validFrom: validFrom,
      validTo: validTo,
      material: material,
      pageNo: page,
      pageSize: sizePerPage,
    };
    dispatch(fetchAll(params));
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="R Detail"></CardHeader>
      <CardBody>
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Rayon Type</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Rayon Type"
                    onChange={(e) => {
                      setRayonType(e.target.value);
                    }}
                    value={rayonType}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Archi Group</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Archi Group"
                    onChange={(e) => {
                      setArchiGroup(e.target.value);
                    }}
                    value={archiGroup}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Division</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Division"
                    onChange={(e) => {
                      setDivision(e.target.value);
                    }}
                    value={division}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Valid From</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="date"
                    placeholder="Valid From"
                    onChange={(e) => {
                      setValidFrom(e.target.value);
                    }}
                    value={validFrom}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Valid To</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="date"
                    placeholder="Valid To"
                    onChange={(e) => {
                      setValidTo(e.target.value);
                    }}
                    value={validTo}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Material </b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Material "
                    onChange={(e) => {
                      setMaterial(e.target.value);
                    }}
                    value={material}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Col>
              <Button className="btn btn-primary" onClick={handleSearch}>
                Search
              </Button>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}
        {data.length > 0 && (
          <RdetailTable
            data={data}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        )}
      </CardBody>
    </Card>
  );
};
